export default __webpack_public_path__ + "static/media/Mark-3-HUD-01.e0fdc8ee.jpg";